// extracted by mini-css-extract-plugin
export default {"heading":"Dx-z","corrected":"Ex-z","redirectVerbiageContainer":"Fx-z","redirectVerbiageText":"Gx-z"};